var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningOutlinedCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99399 14.6667C4.31296 14.663 1.33153 11.6766 1.33399 7.9956C1.33644 4.31457 4.32184 1.33215 8.00287 1.33337C11.6839 1.3346 14.6673 4.31901 14.6673 8.00004C14.6651 11.6836 11.6776 14.6682 7.99399 14.6667ZM2.66732 8.1147C2.69886 11.0489 5.09472 13.4064 8.02901 13.3907C10.9633 13.3749 13.3337 10.9917 13.3337 8.05737C13.3337 5.12304 10.9633 2.73989 8.02901 2.72404C5.09472 2.70834 2.69886 5.06588 2.66732 8.00004V8.1147ZM8.66732 11.3334H7.33399V10H8.66732V11.3334ZM8.66732 8.66671H7.33399V4.6667H8.66732V8.66671Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningOutlinedCircle);
export default __webpack_public_path__ + "static/media/warning-outlined-circle.9de8218d20313ce759a966dac1e6f113.svg";
export { ForwardRef as ReactComponent };